









































































import CollapsiblePanel from "../core/UI/CollapsiblePanel.vue";
import { EmployeApi } from "../api/EmployeApi";
import { Employe } from "../models/Employe";
import TextInput from "../core/Forms/TextInput.vue";
import EmployeContratList from "./EmployeContratList.vue";
import AbsenceList from "./AbsenceList.vue";
import EmployePlanningsEdit from "./EmployePlanningsEdit.vue";
import CheckboxInput from "../core/Forms/CheckboxInput.vue";
import CongeList from "./CongeList.vue";
import DateInput from "../core/Forms/DateInput.vue";
import RadioButtons from "../core/Forms/RadioButtons.vue";
import { Routes } from "../utils/Routes";
import NotesDeFraisList from "./NotesDeFraisList.vue";

export default {
    name: "EmployeEdit",
    components: {
        NotesDeFraisList,
        RadioButtons,
        DateInput,
        CongeList,
        CheckboxInput,
        EmployePlanningsEdit,
        TextInput,
        CollapsiblePanel,
        EmployeContratList,
        AbsenceList,
    },
    props: {
        employeId: Number,
    },
    data() {
        return {
            employe: null,
            civiliteOptions: Employe.Civilite,
            EmployeApi: new EmployeApi(),
            saving: false,
            employes_list_url: Routes.employes_list,
        };
    },
    created() {
        let self = this;
        if (self.employeId) {
            self.EmployeApi.get(self.employeId).then(function (response) {
                self.employe = response;
            });
        } else {
            self.employe = new Employe({});
        }
    },
    methods: {
        saveEmploye() {
            let self = this;
            self.saving = true;
            self.EmployeApi.save(self.employe).then(function (response) {
                self.employe = response;
                self.saving = false;
                window.location.href = Routes.employes_list;
            });
        },
    },
};
